import Button from './button'
import Title from './title'

const ButtonLink = ({ title, buttonName, buttonLink, target }) => {
  const base = 'w-fit flex flex-col items-center lg:items-start'

  return (
    <div className={base}>
      <Title text={title} />
      <Button name={buttonName} link={buttonLink} target={target} />
    </div>
  )
}

export default ButtonLink
